import { useState } from 'react';

const FAQS = [
  {
    q: '本当に転職は無料ですか？',
    a: 'はい、当サービスの利用に費用は一切かかりません。採用が決まった際は勤務先から紹介手数料を頂くモデルのため、求職者様の自己負担はゼロです。',
  },
  {
    q: '在職中なので、現在の職場にバレないか心配です。',
    a: 'ご安心ください。登録内容や相談内容が現在の勤務先など第三者に知られることは決してありません。秘密厳守でサポートいたします。',
  },
  {
    q: 'まだ転職するか決めていなくても相談できますか？',
    a: 'もちろんです！情報収集だけのご相談も大歓迎です。無理に転職を斡旋することは一切ありませんので、「とりあえず話を聞いてみたい」という段階でもお気軽にご利用ください。',
  },
  {
    q: '忙しくて電話に出られないのですが…',
    a: 'ご希望の連絡手段や時間帯を選べます。LINEやメールでの連絡も可能ですので、勤務中は難しい方も隙間時間にやり取りできます。実際、当サービスではLINE連絡を希望される看護師さんも多くいらっしゃいます。',
  },
  {
    q: '紹介してもらえる求人はどんなものがありますか？',
    a: '病院（一般病院から大学病院まで）、クリニック、介護施設、企業の産業看護師など幅広い求人を取り扱っています。地域専任のアドバイザーが各エリアで最大級の求人数からあなたの希望に合った求人をお探しします。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section
      data-track-view="view_faq_section"
      data-element-name="faq_section"
      style={{ padding: '60px 20px', background: '#fff4f4' }}
    >
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        {/* Title */}
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <h2
            style={{
              fontFamily: "'Zen Maru Gothic', sans-serif",
              fontWeight: 900,
              fontSize: 'clamp(24px, 4vw, 32px)',
              color: '#333',
              marginBottom: '12px',
            }}
          >
            よくある質問
          </h2>
          <div
            style={{
              width: '60px',
              height: '4px',
              background: '#fa7c9e',
              borderRadius: '2px',
              margin: '0 auto',
            }}
          />
        </div>

        {/* FAQ Items */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {FAQS.map((faq, i) => (
            <div
              key={i}
              data-track-view="view_question"
              data-element-type="faq_item"
              data-element-name={faq.q.substring(0, 30)}
              data-element-index={i}
              style={{
                background: 'white',
                borderRadius: '10px',
                overflow: 'hidden',
                border: '1.5px solid #ffc8d8',
              }}
            >
              {/* Question */}
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '12px',
                  padding: '16px 20px',
                  background: openIndex === i ? '#fff0f5' : 'white',
                  border: 'none',
                  cursor: 'pointer',
                  textAlign: 'left',
                  transition: 'background 0.2s ease',
                }}
              >
                <span
                  style={{
                    fontSize: '18px',
                    color: '#fa7c9e',
                    fontWeight: 900,
                    lineHeight: 1.4,
                    flexShrink: 0,
                    fontFamily: "'Zen Maru Gothic', sans-serif",
                  }}
                >
                  Q
                </span>
                <span
                  style={{
                    flex: 1,
                    fontWeight: 700,
                    fontSize: '14px',
                    color: '#333',
                    lineHeight: 1.6,
                    paddingTop: '2px',
                  }}
                >
                  {faq.q}
                </span>
                <i
                  className={openIndex === i ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}
                  style={{ color: '#fa7c9e', fontSize: '20px', flexShrink: 0, marginTop: '2px' }}
                />
              </button>

              {/* Answer */}
              {openIndex === i && (
                <div
                  style={{
                    display: 'flex',
                    gap: '12px',
                    padding: '12px 20px 16px 20px',
                    background: '#fff8fb',
                    borderTop: '1px solid #ffd8e8',
                  }}
                >
                  <span
                    style={{
                      fontSize: '18px',
                      color: '#ff5c73',
                      fontWeight: 900,
                      lineHeight: 1.4,
                      flexShrink: 0,
                      fontFamily: "'Zen Maru Gothic', sans-serif",
                    }}
                  >
                    A
                  </span>
                  <p
                    style={{
                      fontSize: '13px',
                      fontWeight: 500,
                      color: '#555',
                      lineHeight: 1.8,
                      paddingTop: '2px',
                    }}
                  >
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}